(() => {
  const status = document.querySelector('.copy-status');
  let timer;
  document.querySelectorAll('[data-copy]').forEach(button => {
    button.addEventListener('click', async () => {
      const source = document.getElementById(button.dataset.copy);
      const text = source.value || source.textContent.trim();
      try {
        await navigator.clipboard.writeText(text);
        status.textContent = button.dataset.copy === 'release-text' ? 'Press release copied.' : 'Caption and credit copied.';
      } catch {
        const area = document.createElement('textarea');
        area.value = text;
        area.style.cssText = 'position:fixed;left:12px;bottom:12px;width:calc(100% - 24px);height:130px;z-index:10';
        area.setAttribute('aria-label', 'Select and copy this text');
        document.body.append(area);
        area.focus();
        area.select();
        area.addEventListener('blur', () => area.remove(), { once: true });
        status.textContent = 'Text selected. Copy using your keyboard or device menu.';
      }
      status.classList.add('show');
      clearTimeout(timer);
      timer = setTimeout(() => status.classList.remove('show'), 4000);
    });
  });
  document.querySelectorAll('video').forEach(video => {
    video.addEventListener('play', () => {
      document.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); });
    });
  });
})();
